import { Injectable } from '@angular/core';

import { EAppMode } from '@common/enums';

@Injectable({
    providedIn: 'root',
})
export class EcommerceResolver {
    public resolve(): EAppMode {
        return EAppMode.ECOMMERCE;
    }
}
